<template>
  <Modal v-if="showModal" @close="$emit('closeModal')">
    <div class="infoReservation">
      <div class="infoReservation__header">
        <span class="title">{{ $t('infoReservation') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <GeneralInfoReservation
        :openGeneralInfoReservation="openGeneralInfoReservation"
        :activeDelivery="activeDelivery"
      />
      <div class="infoReservation__buttons">
        <Button
          variant="bordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import GeneralInfoReservation from '@/duplicatePages/GeneralInfoReservation/GeneralInfoReservation.vue';

@Options({
  name: 'InfoReservation',
  emits: ['closeModal'],
  props: ['showModal', 'activeDelivery'],
  components: {
    GeneralInfoReservation
  },
  data() {
    return {
      openGeneralInfoReservation: false
    };
  },
  watch: {
    showModal() {
      if (this.showModal) {
        this.openGeneralInfoReservation = true;
      }
    }
  }
})
export default class InfoReservation extends Vue {}
</script>

<style lang="scss" scoped>
.infoReservation {
  max-width: 700px;
  height: 100%;
  padding: 24px;
  .infoReservation__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
}
</style>
